<template>
  <div>
    <div class="form-group">
      <!-- <input :disabled="disabled" :value="value" :id="id" class="form-control" @input="update()" ref="input" />-->
      <label :for="id" v-if="text">{{ text }}</label>
      <p
        v-for="option in options"
        v-bind:key="option.value"
        class="option-radio"
      >
        <input
          type="radio"
          :name="id"
          :disabled="disabled"
          :value="option.value"
          :id="id + option.value"
          @input="update(option.value)"
          :checked="option.value == value"
        />
        <label :for="id + option.value">{{ option.label }}</label>
        <slot :name="option.value"></slot>
      </p>
    </div>
  </div>
</template>
<script>
import placeholder from "@mixins/placeholder.js";
export default {
  name: "volcan-input-radio",
  mixins: [placeholder],
  props: {
    text: String,
    syncSeo: Boolean,
    disabled: Boolean,
    options: Array,
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  methods: {
    update(val) {
      this.$emit("input", val);
    },
  },
};
</script>
<style>
.option-radio {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-radio.vue